import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Po przejściu na inny ekran zaczynamy od góry strony (router domyślnie zostawia poprzednie przewinięcie,
// przez co np. w edytorach przyciski „Wróć” chowały się pod menu). Linki z kotwicą (#Kontakt) przewija HashLink.
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();

    useEffect(() => {
        if (!hash) window.scrollTo(0, 0);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pathname]);

    return null;
}
